<template>
    <div>
        <b-modal id="modal-prevent-closing" centered class="header-modal" no-close-on-backdrop hide-footer
            ref="instruction-prepare-questions">
            <div class="modal-delete-lesson__body container wrap-form-create-update-chapter">
                <!-- <h4>
                    <strong>
                        Xóa {{ getNameType }}
                    </strong>
                </h4>
                <p class="font-size-20 text-center primary-color-txt font-sanpro-light">
                    Bạn có muốn xóa {{ getNameType }} này không? <br />
                </p> -->
                <div class="modal__actions">
                    <img class="icon-close btn-close custom-cursor float-right" src="@/assets/img/x.png"
                        @click="handleHideModal" />
                    <h4><strong>Trợ giúp</strong></h4>
                    <!-- <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal"></a> -->
                    <!-- <a href="javascript:;" class="btn btn-err font-size-17 font-sanpro-semibold btn-delete" @click="handleDelete()">Đồng ý</a> -->
                </div>

                <div class="modal__contents">

                    <p>Hướng dẫn sử dụng chức năng</p>
                    <video width="320" height="240" controls>
                        <source src="https://www.youtube.com/watch?v=jyoFEA0o1XQ" type="">
                        Your browser does not support the video tag.
                    </video>
                    <!-- <iframe width="420" height="345" src="https://www.youtube.com/watch?v=jyoFEA0o1XQ">
                    </iframe> -->

                </div>

            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "ModalInstructionPrepareQuestion",
    mounted() {
        this.handleShowModal()
    },
    methods: {
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['instruction-prepare-questions'].show()
        },
    }
}
</script>

<style lang="scss" scoped>
/* .btn-cancel {
    color: black;
    background-color: red;
    border-radius: 50%;
    
} */

.btn-close {
    width: 10px;
}

.custom-cursor {
    cursor: pointer;
}

.float-right {
    float: right;
}
</style>